import {post} from '../request';

/**
 * 管理员列表
 * @param data
 * @returns {*}
 */
export function adminIndex(data) {
    return post("admin/admin.index/index", data)
}

/**
 * 新增管理员
 * @param data
 * @returns {*}
 */
export function adminCreate(data) {
    return post("admin/admin.index/create", data)
}

/**
 * 编辑管理员
 * @param data
 * @returns {*}
 */
export function adminEdit(data) {
    return post("admin/admin.index/edit", data)
}

/**
 * 锁定管理员
 * @param data
 * @returns {*}
 */
export function adminLock(data) {
    return post("admin/admin.index/lock", data)
}

/**
 * 设置安抚金额
 * @param data
 * @returns {*}
 */
 export function setmoney(data) {
    return post("admin/admin.worker/setmoney", data)
}

/**
 * 管理员改价权限
 * @param data
 * @returns {*}
 */
export function adminChangePrice(data) {
    return post("admin/admin.index/IsChangePrice", data)
}

/**
 * 获得所有COde
 * @param data
 * @returns {*}
 */
export function authCode(data) {
    return post("admin/admin.role/getAuthCode", data)
}

/**
 * 角色列表
 * @param data
 * @returns {*}
 */
export function roleList(data) {
    return post("admin/admin.role/index", data)
}


/**
 * 新增角色
 * @param data
 * @returns {*}
 */
export function roleCrate(data) {
    return post("admin/admin.role/create", data)
}

/**
 * 编辑角色
 * @param data
 * @returns {*}
 */
export function roleEdit(data) {
    return post("admin/admin.role/edit", data)
}

/**
 * 获取员所有工身份
 * @param data
 * @returns {*}
 */
export function getIdentity(data) {
    return post("admin/admin.worker/getIdentity", data)
}

/**
 * 获员工身份所对应的权限
 * @param data
 * @returns {*}
 */
export function getAppletAuth(data) {
    return post("admin/admin.worker/getAppletAuth", data)
}

/**
 *添加api员工权限
 * @param data
 * @returns {*}
 */
export function addWorker(data) {
    return post("admin/admin.worker/addWorker", data)
}

export function editWorker(data) {
    return post("admin/admin.worker/editWorker", data)
}

/**
 *添加api员工权限lieb
 * @param data
 * @returns {*}
 */
export function workerIndex(data) {
    return post("admin/admin.worker/index", data)
}

export function getStore(data) {
    return post("admin/admin.worker/getStore", data)
}

// 获取所有管理员
export function getAllWorker(data){
    return post("admin/admin.worker/getWorker",data)
}

// 获取师傅轨迹
export function getTrajectory(data){
    return post("admin/admin.worker/getTrajectory",data)
}

// 员工查看补卷明细
export function getfillingvolume(data){
    return post("admin/admin.worker/fillingvolumelist",data)
}